import React from 'react';
import { Store, ShoppingBag, Truck } from 'lucide-react';
import { cn } from '@/lib/utils';

export type OrderTypeOption = 'dine-in' | 'pickup' | 'delivery';

interface OrderTypeSelectorProps {
  value: OrderTypeOption;
  onChange: (value: OrderTypeOption) => void;
  disabled?: boolean;
}

const orderTypes = [
  {
    value: 'dine-in' as const,
    label: 'Balcão',
    icon: Store,
    color: 'text-blue-600 bg-blue-50 border-blue-200 hover:bg-blue-100',
    activeColor: 'bg-blue-600 text-white border-blue-600',
  },
  {
    value: 'pickup' as const,
    label: 'Retira',
    icon: ShoppingBag,
    color: 'text-amber-600 bg-amber-50 border-amber-200 hover:bg-amber-100',
    activeColor: 'bg-amber-600 text-white border-amber-600',
  },
  {
    value: 'delivery' as const,
    label: 'Delivery',
    icon: Truck,
    color: 'text-green-600 bg-green-50 border-green-200 hover:bg-green-100',
    activeColor: 'bg-green-600 text-white border-green-600',
  },
];

const OrderTypeSelector: React.FC<OrderTypeSelectorProps> = ({
  value,
  onChange,
  disabled = false,
}) => {
  return (
    <div className="grid grid-cols-3 gap-2">
      {orderTypes.map((type) => {
        const Icon = type.icon;
        const isActive = value === type.value;
        
        return (
          <button
            key={type.value}
            type="button"
            disabled={disabled}
            onClick={() => onChange(type.value)}
            className={cn(
              'flex flex-col items-center justify-center p-3 rounded-lg border-2 transition-all duration-200',
              isActive ? type.activeColor : type.color,
              disabled && 'opacity-50 cursor-not-allowed'
            )}
          >
            <Icon className="h-6 w-6 mb-1" />
            <span className="text-sm font-medium">{type.label}</span>
          </button>
        );
      })}
    </div>
  );
};

export default OrderTypeSelector;
